import React, { useEffect, useState } from "react";
import { http } from "@/lib/api";
import PropertyCard from "@/components/PropertyCard";
import { Search } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function Properties() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState({ city: "", property_type: "", min_bedrooms: "", max_price: "" });
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const params = {};
    Object.entries(q).forEach(([k, v]) => { if (v !== "" && v != null) params[k] = v; });
    try { const { data } = await http.get("/properties", { params }); setItems(data); } finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-14">
      <p className="text-xs font-bold uppercase tracking-widest text-[color:var(--wv-green-dark)]">{t("properties.kicker")}</p>
      <h1 className="font-display text-4xl md:text-5xl font-extrabold text-[color:var(--wv-obsidian)] mt-2">{t("properties.title")}</h1>

      <div className="mt-8 p-5 bg-white border border-slate-200 rounded-2xl grid md:grid-cols-5 gap-3">
        <input className="wv-input md:col-span-2" placeholder={t("properties.filter_city_ph")} value={q.city} onChange={(e) => setQ({ ...q, city: e.target.value })} data-testid="filter-city" />
        <select className="wv-input" value={q.property_type} onChange={(e) => setQ({ ...q, property_type: e.target.value })} data-testid="filter-type">
          <option value="">{t("properties.filter_all_types")}</option>
          {["appartement", "tussenwoning", "hoekwoning", "2-onder-1-kap", "vrijstaand", "bungalow"].map(x => <option key={x} value={x}>{x}</option>)}
        </select>
        <input className="wv-input" type="number" min="0" placeholder={t("properties.filter_min_bedrooms_ph")} value={q.min_bedrooms} onChange={(e) => setQ({ ...q, min_bedrooms: e.target.value })} data-testid="filter-bedrooms" />
        <input className="wv-input" type="number" min="0" placeholder={t("properties.filter_max_price_ph")} value={q.max_price} onChange={(e) => setQ({ ...q, max_price: e.target.value })} data-testid="filter-max-price" />
        <button className="wv-btn-primary md:col-span-5 inline-flex items-center justify-center gap-2" onClick={load} data-testid="filter-search-btn">
          <Search className="w-4 h-4" /> {t("properties.search")}
        </button>
      </div>

      <div className="mt-8">
        {loading ? (
          <p className="text-slate-500">{t("loading")}</p>
        ) : items.length === 0 ? (
          <div className="p-10 text-center border border-dashed border-slate-300 rounded-2xl">
            <p className="text-lg text-slate-600">{t("properties.empty_title")}</p>
            <a href="/woning-zoeken" className="inline-flex mt-4 wv-btn-green" data-testid="empty-create-profile">{t("properties.empty_cta")}</a>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((p) => <PropertyCard key={p.id} p={p} />)}
          </div>
        )}
      </div>
    </div>
  );
}
